'use strict';

import React from 'react';
import { ObjFactory, PrmFactory } from 'rt-sd-common';
import { SgiMainComp } from 'rt-sd-comp';
import { apJSLoading } from '../appInit';
import { bussLoading } from '../bussInit';

const startWith = function (str, start) {
    var reg = new RegExp("^" + start);
    return reg.test(str);
}

class UIPreview extends React.Component {
    constructor(props) {
        super(props);

        var params = this.props.location.query;

        this.state = {
            uuid: "",
        }

        apJSLoading(); //第二次刷新的时候用
        bussLoading();
    }

    GetRequest = function () {
        var url = location.search; //获取url中"?"符后的字串   
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            }
        }
        return theRequest;
    }

    render = function () {

        var params = this.props.location.query;

        var transferData;
        var uid;
        if (params) {
            const uuid = params.uuid;
            // if (uuid !== this.state.uuid) this.saveEcho();//uuid变更，存储回显数据
            this.state.uuid = uuid;
            transferData = JSON.parse((unescape(tool.sgiStorage.get(sgiConfig.keyPre_uuid + uuid))));
            if (!transferData) {
                // tool.popMessage("页面已过期！", "warning");
                tool.popSingleUI("/");
            } else {
                uid = transferData.uid;
            }
        }

        return this.getUI(uid, transferData);
    }

    getUI(uid, transferData) {
        if (!uid) {
            return null;
        } else if (startWith(uid, "/") || startWith(uid, "http://") || startWith(uid, "https://")) {
            // url或http地址
            return <iframe src={uid} height="100%" width="100%" style={{ verticalAlign: "top" }} frameBorder=""></iframe>;
        } else {
            // guid参数
            let ucvData = PrmFactory.getPrm(uid);
            if (!ucvData) return null;
            var objFct = new ObjFactory(uid, transferData);
            return (
                <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                    {/* <MainBreadcrumb breadcrumbList={[{ name: '我的项目', path: '/main/myProjMainPage' }, 
                            { name: tool.Global.currentAP + '项目', path: '/dev/DevMainPage' },
                            { name: uidSplit[2] + '开发' }]} /> */}
                    {/* <div style={{ height: '100%', width: '100%' }}> */}
                    <SgiMainComp key={tool.uuid(8)} objFct={objFct} moduleDesc={ucvData}>
                    </SgiMainComp>
                    {/* </div> */}
                </div>
            );
        }
    }

    saveEcho() {
        let objFct = this.state.objFct;
        if (objFct && objFct.get("#echo")) {
            let saveKeyList = objFct.get("#echo");
            if (typeof saveKeyList === "string") saveKeyList = saveKeyList.split(",");
            let transferData = {};
            saveKeyList.forEach(key => {
                transferData[key] = objFct.get(key);
            });
            let value = escape(JSON.stringify(transferData));
            tool.sgiStorage.set(sgiConfig.keyPre_uuid + this.state.uuid, value);
        }
    }

    //防止 走2遍
    // shouldComponentUpdate() {
    // var params = this.props.location.query;
    // // POP 浏览器前进后退， PUSH 点击Link
    // tool.sgiLogger.info("this.props.location.action:" + this.props.location.action);
    // return this.props.location.action === "PUSH" || this.state.uuid == params.uuid;
    // return  this.state.uuid != params.uuid
    // }
}

export { UIPreview };



// WEBPACK FOOTER //
// ./apps/project/dev/UIPreview.js